import { ChangeDetectionStrategy, Component, inject, Signal, ViewEncapsulation } from '@angular/core';
import { DateFormatPipe } from '@ui-components';
import { StreamChatModule } from 'stream-chat-angular';
import { ChatNavbarComponent } from '../chat-navbar/chat-navbar.component';
import {
  ChannelDetailsQueryHandler,
  ChannelDetailsQueryResult,
  CreateSingleChatCommandHandler
} from '../../application/handlers';
import { CustomMessageListComponent } from './custom-message-list/custom-message-list.component';
import { CustomMessageInputComponent } from './custom-message-input/custom-message-input.component';
import { ChatViewService } from './view-service/chat.view-service';

@Component({
  selector: 'lib-chat',
  templateUrl: './chat.component.html',
  styleUrls: ['./chat.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [
    StreamChatModule,
    ChatNavbarComponent,
    DateFormatPipe,
    CustomMessageListComponent,
    CustomMessageInputComponent
  ],
  providers: [ChatViewService, ChannelDetailsQueryHandler, CreateSingleChatCommandHandler, DateFormatPipe]
})
export class ChatComponent {
  private readonly viewService: ChatViewService = inject(ChatViewService);

  readonly isPageLoaded: Signal<boolean> = this.viewService.isPageLoaded;
  readonly isPending: Signal<boolean> = this.viewService.isPending;
  readonly channelDetails: Signal<ChannelDetailsQueryResult | undefined> = this.viewService.channelDetails;

  manageChannel(): void {
    this.viewService.manageChannel();
  }

  stopWatching(): void {
    this.viewService.stopWatching();
  }
}
